import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../Variables";
import { disconnectSocket } from "../services/Socket";

/**
 * Use this component to protect routes that should only be accessible by an admin user.
 * @param {*} children - The component to render if the user is an admin
 * @returns - The component to render if the user is an admin, otherwise redirect to the login page
 */
const AdminProtectedRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(null);
  const navigate = useNavigate();

  // Check if the user is an admin
  useEffect(() => {
    let isCancelled = false;

    const checkAdmin = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setIsAdmin(false);
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/auth/verify-token`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!isCancelled) {
          const userTypeId = response.data?.user_type_id;
          if (userTypeId === 1) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
            navigate("/home");
          }
        }
      } catch (error) {
        if (!isCancelled) {
          setIsAdmin(false);
          localStorage.removeItem("token");
          disconnectSocket();
          navigate("/login");
        }
      }
    };

    checkAdmin();

    return () => {
      isCancelled = true;
    };
  }, [navigate]);

  if (isAdmin === null) {
    return <div>Loading...</div>;
  }

  return isAdmin ? children : <Navigate to="/login" />;
};

export default AdminProtectedRoute;
